// extracted by mini-css-extract-plugin
export default {"priority-modal":"NewWorkflow_priority-modal__YphhO","actions":"NewWorkflow_actions__+Ee3b"};